import React, { useState } from 'react';
import { menuCategories } from '../data/mock';

const MenuSection = () => {
  const [activeCategory, setActiveCategory] = useState(1);

  const formatPrice = (price) => {
    return `${price} ₺`;
  };

  return (
    <section id="menu" className="py-20 lg:py-32 bg-[#f6f5e8]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#722F37] text-sm font-medium tracking-widest uppercase mb-4">
            Lezzetlerimiz
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#333333] mb-6">
            Menümüz
          </h2>
          <p className="text-[#666666] text-lg max-w-2xl mx-auto">
            %100 helal kesim etlerle hazırlanan, geleneksel tariflerimizle sizlere sunduğumuz lezzetler.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-12">
          {menuCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-5 py-3 text-sm font-medium transition-all duration-200 ${
                activeCategory === category.id
                  ? 'bg-[#722F37] text-white'
                  : 'bg-white text-[#333333] hover:bg-[#722F37]/10'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Menu Items */}
        <div className="flex flex-wrap justify-center gap-6">
          {menuCategories
            .find((cat) => cat.id === activeCategory)
            ?.items.map((item) => (
              <div
                key={item.id}
                className={`bg-white p-6 transition-all duration-200 hover:shadow-lg w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] max-w-sm ${
                  item.featured ? 'ring-2 ring-[#722F37]' : ''
                }`}
              >
                {item.featured && (
                  <span className="inline-block bg-[#722F37] text-white text-xs px-3 py-1 mb-4">
                    Özel Tarif
                  </span>
                )}
                
                <h3 className="font-display text-xl text-[#333333] mb-2">
                  {item.name}
                </h3>
                
                {item.description && (
                  <p className="text-[#666666] text-sm mb-4 leading-relaxed">
                    {item.description}
                  </p>
                )}

                {/* Price Display */}
                {item.variants ? (
                  <div className="space-y-2 pt-4 border-t border-[#ebeade]">
                    {item.variants.map((variant, idx) => (
                      <div key={idx} className="flex justify-between items-center">
                        <span className="text-[#666666] text-sm">{variant.size}</span>
                        <span className="text-[#722F37] font-semibold">{formatPrice(variant.price)}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="pt-4 border-t border-[#ebeade]">
                    <span className="text-[#722F37] font-semibold text-lg">{formatPrice(item.price)}</span>
                  </div>
                )}
              </div>
            ))}
        </div>

        {/* Menu Note */}
        <div className="mt-12 text-center">
          <p className="text-[#666666] text-sm">
            * Fiyatlarımız güncel olup, değişiklik gösterebilir. Detaylı bilgi için bizimle iletişime geçiniz.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;